import React, { createContext, useContext, useState } from 'react';
import { Invoice } from '@/types';

interface PaymentContextType {
  currentInvoice: Invoice | null;
  setCurrentInvoice: (invoice: Invoice | null) => void;
}

const PaymentContext = createContext<PaymentContextType | undefined>(undefined);

export function usePayment() {
  const context = useContext(PaymentContext);
  if (context === undefined) {
    throw new Error('usePayment must be used within a PaymentProvider');
  }
  return context;
}

export function PaymentProvider({ children }: { children: React.ReactNode }) {
  const [currentInvoice, setCurrentInvoice] = useState<Invoice | null>(null);

  const value: PaymentContextType = {
    currentInvoice,
    setCurrentInvoice,
  };

  return <PaymentContext.Provider value={value}>{children}</PaymentContext.Provider>;
}

